export default "__VITE_ASSET__06747141__"